import 'angular-spinner';

export default 'angularSpinner';
